"use client";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  // CarouselApi,
} from "@/components/ui/carousel";
// import { PaginationDots } from "@/components/common";

export interface HelpSectionCard {
  title: string;
  points: string[];
  isPrimary?: boolean;
}

interface HelpSectionProps {
  title?: string;
  subtitle?: string;
  cards?: HelpSectionCard[];
  className?: string;
}

const HelpSection: React.FC<HelpSectionProps> = ({
  title = "How can we help you?",
  subtitle = "",
  cards = [],
  className = "",
}) => {
  // const [current, setCurrent] = React.useState(0);
  // const [carouselApi, setCarouselApi] = React.useState<CarouselApi | null>(
  //   null
  // );

  // React.useEffect(() => {
  //   if (!carouselApi) return;

  //   const onSelect = () => setCurrent(carouselApi.selectedScrollSnap());
  //   onSelect();
  //   carouselApi.on("select", onSelect);

  //   return () => {
  //     carouselApi.off("select", onSelect);
  //   };
  // }, [carouselApi]);

  return (
    <section className={`py-16 md:py-20 ${className}`}>
      <div className="flex sm:max-w-[80rem] mx-auto xl:px-20 md:px-10 flex-col gap-4 w-full">
        <div className="flex flex-col gap-4 items-center justify-center px-6 sm:px-0">
          <h2 className="font-bold text-secondary text-center max-w-[45rem]">
            {title}
          </h2>
          {subtitle && (
            <p className="text-muted-2-foreground text-sm text-center md:text-base lg:w-[60%]">
              {subtitle}
            </p>
          )}
        </div>

        <div className="w-full m-0 justify-center gap-8 overflow-x-auto">
          <Carousel
            // setApi={setCarouselApi}
            opts={{ loop: false }}
            className="w-full"
            aria-label="Help topics"
          >
            <CarouselContent className="py-2">
              {cards.map((card, index) => (
                <CarouselItem
                  key={index}
                  className="xl:basis-1/3 basis-auto px-3"
                >
                  <Card
                    className={`sm:p-4 p-2 flex flex-col min-h-full gap-4 border sm:w-full xs:w-[20rem] w-[93vw] ${
                      card.isPrimary
                        ? "border-[#fdd9d2] [background:linear-gradient(155deg,rgba(255,255,255,1)_0%,rgba(254,243,240,1)_100%)]"
                        : "border-[#e6e6e6]"
                    } rounded-[10px]`}
                  >
                    <CardContent className="lg:p-4 flex flex-col items-center lg:gap-6 p-4 gap-4">
                      <div className="flex flex-col items-center lg:gap-6 w-full gap-2">
                        <h3 className="text-center font-medium text-secondary text-[16px] xs:text-[18px] sm:text-[22px] leading-[130%]">
                          {card.title}
                        </h3>

                        <div className="flex justify-center w-full">
                          <div className="flex flex-col items-start gap-2">
                            {card.points.map((point, pointIndex) => (
                              <p
                                key={pointIndex}
                                className="flex items-start gap-2 text-muted-2-foreground"
                              >
                                <span className="text-muted-2-foreground">
                                  •
                                </span>
                                <span>{point}</span>
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
{/* 
      <PaginationDots
        total={cards.length}
        current={current}
        onDotClick={(index) => carouselApi?.scrollTo(index)}
      /> */}
    </section>
  );
};

export default HelpSection;
